module.exports = __webpack_public_path__ + "img/cloud-logo-no-text.8354c062.svg";